import React, { useEffect, useState } from 'react';

const AmbientGlow = () => {
  const [pos, setPos] = useState({ x: -200, y: -200 });

  useEffect(() => {
    let animationFrameId;
    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight / 2;
    let currentX = targetX;
    let currentY = targetY;

    const handleMouseMove = (e) => {
      targetX = e.clientX;
      targetY = e.clientY;
    };

    const animate = () => {
      // Smooth lerp follow
      currentX += (targetX - currentX) * 0.08;
      currentY += (targetY - currentY) * 0.08;

      setPos({ x: currentX, y: currentY });
      animationFrameId = requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    animationFrameId = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <>
      {/* Fixed Atmospheric Ambient Orbs */}
      <div 
        aria-hidden="true"
        className="pointer-events-none fixed top-[-100px] right-[-100px] w-[500px] h-[500px] rounded-full bg-gradient-to-br from-cyan-500/15 via-blue-600/10 to-transparent blur-[140px] z-0"
      />
      <div 
        aria-hidden="true"
        className="pointer-events-none fixed top-[45%] left-[-150px] w-[600px] h-[600px] rounded-full bg-gradient-to-tr from-indigo-600/12 via-purple-600/10 to-transparent blur-[150px] z-0"
      />
      <div 
        aria-hidden="true"
        className="pointer-events-none fixed bottom-[-100px] right-[10%] w-[550px] h-[550px] rounded-full bg-gradient-to-tl from-emerald-500/12 via-teal-600/8 to-transparent blur-[140px] z-0"
      />

      {/* Interactive Mouse-Following Glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed z-0 -translate-x-1/2 -translate-y-1/2 w-[650px] h-[650px] rounded-full opacity-35 dark:opacity-45 blur-[130px] transition-opacity duration-500 will-change-transform"
        style={{
          left: `${pos.x}px`,
          top: `${pos.y}px`,
          background: 'radial-gradient(circle, rgba(56,189,248,0.45) 0%, rgba(99,102,241,0.3) 38%, rgba(16,185,129,0.18) 65%, transparent 80%)',
        }}
      />
    </>
  );
};

export default AmbientGlow;
